export default "__VITE_ASSET__B5LiAs3O__"